/**
 * Reads a `File`/`Blob` into a base64 string (without the data-URL prefix) using
 * the browser's native `FileReader`, keeping the encoding off the main thread.
 * Resolves `null` when the file can't be read. Preferred over a manual
 * `btoa`/byte-loop, which blocks the UI for large (multi-MB) attachments.
 */
export function readFileAsBase64(file: File | Blob): Promise<string | null> {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = typeof reader.result === 'string' ? reader.result : ''
      const commaIndex = result.indexOf(',')
      resolve(commaIndex >= 0 ? result.slice(commaIndex + 1) : null)
    }
    reader.onerror = () => resolve(null)
    reader.readAsDataURL(file)
  })
}
